import ProgramOverview from 'components/views/ProgramOverview';
import i18n from 'helper/i18n';
import { generateSignature } from 'helper/signature';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getActivityLevel, getGender, getHealthGoal, getUserData } from 'store/profile';
import {
	actionCreators as programOverviewAC,
	getLoadingState,
	getNotRecommendedPrograms,
	getRecommendedPrograms,
} from 'store/programOverview';
import { RootStateType as ProgramOverviewRootStateType } from 'store/programOverview';
import { IRootState } from 'store/rootReducer';
import { getCurrentViewID } from 'store/view';
import { RootStateType as ViewRootStateType } from 'store/view';

export type ContainerRootStateType = IRootState & ViewRootStateType & ProgramOverviewRootStateType;

const mapStateToProps = (state: ContainerRootStateType) => {
	const notRecommendedPrograms = getNotRecommendedPrograms(
		state,
		getActivityLevel(state),
		getHealthGoal(state),
		getGender(state)
	);
	const recommendedPrograms = getRecommendedPrograms(
		state,
		getActivityLevel(state),
		getHealthGoal(state),
		getGender(state)
	);
	const userData = getUserData(state);
	const loading = getLoadingState(state);
	const currentViewID = getCurrentViewID(state);

	return {
		loading,
		userData,
		currentViewID,
		recommendedPrograms,
		allPrograms: notRecommendedPrograms,
		selectedUserActivityLevel: getActivityLevel(state),
		selectedUserHealthGoal: getHealthGoal(state),
		filterSignature: generateSignature(loading, recommendedPrograms, notRecommendedPrograms),
		filters: [
			{
				id: 'recommended',
				label: i18n('react.impulsCoach.views.programOverview.filters.recommended'),
				count: recommendedPrograms.length,
			},
			{
				id: 'all',
				label: i18n('react.impulsCoach.views.programOverview.filters.all'),
				count: (notRecommendedPrograms || ({} as any)).length,
			},
		],
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doLoadOverview: programOverviewAC.doLoadOverview,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgramOverview as any);
